<template>
  <lb-dialog
    v-model="localValue"
    v-if="localValue"
    heading="Warning"
    width="45%"
    :content-class="contentClass"
    data-testid="gl-tab-warning-dialog"
  >
    <template v-slot:body>
      <div class="d-flex flex-column gap-4 pa-4" data-testid="gl-tab-warning-dialog__body">
        <div class="d-flex gap-2">
          <img src="/img/icons/AlertIcon.svg" alt="Warning Icon" width="32" height="32" />
          <div class="d-flex flex-column gap-2">
            <h3 class="font-weight-semibold Warning" data-testid="gl-tab-warning-dialog__title">Warning</h3>
            <h5 class="Warning--text font-weight-medium" data-testid="gl-tab-warning-dialog__message">
              {{ message }}
            </h5>
            <ul
              v-if="fields && fields.length"
              class="Warning--text font-weight-medium pl-4 mb-0 mt-2"
              data-testid="gl-tab-warning-dialog__fields"
            >
              <li v-for="(field, index) in fields" :key="`${field}-${index}`">{{ field }}</li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <div class="d-flex justify-end gap-2">
        <v-btn outlined color="primary" elevation="0" @click="handleCancel" data-testid="gl-tab-warning-dialog__cancel-btn">
          Cancel
        </v-btn>
        <v-btn color="primary" elevation="0" @click="handleConfirm" data-testid="gl-tab-warning-dialog__confirm-btn">
          Confirm
        </v-btn>
      </div>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'GlTabWarningDialog',
  props: {
    value: { type: Boolean, default: false },
    message: {
      type: String,
      default: 'Please save your changes before switching tabs. Unsaved changes will be lost.',
    },
    fields: {
      type: Array,
      default: () => [],
    },
    contentClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
      this.$emit('input', false);
    },
    handleConfirm() {
      this.$emit('confirm');
      this.$emit('input', false);
    }
  }
}
</script>
